import React from 'react';
import { InView } from 'react-intersection-observer';

import IconClose from '@components/Images/Rebranding/IconClose';
import useEventTracking from '@hooks/useEventTracking';
import Modal from '@mui/material/Modal';
import { ImpressionElement, TrackingLocation, impression } from '@tracking';

import { GroupAdmin, GroupUser, UserOperationType } from '../../types';
import UserForm from './UserForm';

interface UserModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: GroupAdmin | GroupUser;
  operation: UserOperationType;
}

const UserModal = ({ isOpen, onClose, user, operation }: UserModalProps) => {
  const location = `${user.type}_user_${TrackingLocation.Modal}`;
  const { trackEvent, Track } = useEventTracking({
    location,
  });

  const handleImpression = () => {
    trackEvent(impression({ impressionElement: ImpressionElement.Modal }));
  };

  return (
    <Track>
      <Modal data-testid="user-modal" open={isOpen} onClose={onClose}>
        <div className="absolute left-1/2 top-1/2 z-[1020] w-[calc(100%-16px)] -translate-x-1/2 -translate-y-1/2 rounded-2 bg-white outline-none md:w-[924px]">
          <InView
            triggerOnce={true}
            onChange={(inView) => {
              inView && handleImpression();
            }}
          >
            <div className="relative flex h-full justify-center px-16">
              <IconClose
                data-testid="close-button"
                className="close-button absolute right-8 top-8 w-20 cursor-pointer text-grayscale-charcoal sm:right-16 sm:top-16 sm:w-[26px]"
                onClick={onClose}
                role="button"
              />
              <div className="mb-20 mt-40 w-full sm:mb-72 sm:mt-56 sm:w-[624px]">
                <UserForm user={user} operation={operation} onClose={onClose} />
              </div>
            </div>
          </InView>
        </div>
      </Modal>
    </Track>
  );
};

export default UserModal;
